import { useEffect, useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { ProtectedRoute } from './features/auth/ProtectedRoute.jsx';
import { RequireRole } from './features/auth/RequireRole.jsx';
import { intentarRefreshSilencioso } from './features/auth/useAuth.js';
import { useAuthStore } from './stores/authStore.js';
import AppShell from './components/layout/AppShell.jsx';
import LoginPage from './pages/LoginPage.jsx';
import DashboardPage from './pages/DashboardPage.jsx';
import LeadsPage from './pages/LeadsPage.jsx';
import LeadDetallePage from './pages/LeadDetallePage.jsx';
import RecordatoriosPage from './pages/RecordatoriosPage.jsx';
import UsuariosPage from './pages/UsuariosPage.jsx';
import ObjetivosPage from './pages/ObjetivosPage.jsx';
import WhatsAppPage from './pages/WhatsAppPage.jsx';

export default function App() {
  const setAuth = useAuthStore((s) => s.setAuth);
  const [cargando, setCargando] = useState(true);

  useEffect(() => {
    intentarRefreshSilencioso(setAuth).finally(() => setCargando(false));
  }, []);

  if (cargando) {
    return (
      <div className="min-h-screen bg-[#F5F5F5] flex items-center justify-center">
        <span className="font-['Raleway'] text-[#0D2B5C] text-sm">Cargando...</span>
      </div>
    );
  }

  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route element={<ProtectedRoute />}>
        <Route element={<AppShell />}>
          <Route index element={<Navigate to="/dashboard" replace />} />
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/leads" element={<LeadsPage />} />
          <Route path="/leads/:id" element={<LeadDetallePage />} />
          <Route path="/recordatorios" element={<RecordatoriosPage />} />
          <Route element={<RequireRole role="admin" />}>
            <Route path="/whatsapp" element={<WhatsAppPage />} />
            <Route path="/usuarios" element={<UsuariosPage />} />
            <Route path="/objetivos" element={<ObjetivosPage />} />
          </Route>
        </Route>
      </Route>
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}
